var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"mb-[20px]"},[_c(_setup.StatisticBlock,{attrs:{"data":_setup.displayData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }